import React, { useState } from "react";
import styled from "styled-components";
import { color, font } from "../../theme/tokens";

const Frame = styled.div`
  width: 100%;
  aspect-ratio: 1 / 1;
  overflow: hidden;
  background: ${color.paperDeep};
`;

const Img = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`;

const Initials = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: ${font.display};
  font-size: 34px;
  font-weight: 400;
  letter-spacing: 0.02em;
  color: ${color.inkMuted};
  background: ${color.paperDeep};
`;

const initialsFor = (name = "") =>
  name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0])
    .join("")
    .toUpperCase();

/**
 * Square portrait that degrades to an initials tile when the image is missing
 * or fails to load, so a not-yet-uploaded headshot never shows a broken icon.
 */
export default function Portrait({ src, name, className }) {
  const [failed, setFailed] = useState(false);
  const showImage = Boolean(src) && !failed;

  return (
    <Frame className={className}>
      {showImage ? (
        <Img src={src} alt={name} onError={() => setFailed(true)} />
      ) : (
        <Initials aria-label={name}>{initialsFor(name)}</Initials>
      )}
    </Frame>
  );
}
